import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Car, LogOut } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";

export default function PortalLayout({ title, nav }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col" data-testid="portal-layout">
      <header className="bg-slate-900 text-white border-b border-slate-800 sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto flex items-center justify-between px-4 lg:px-6 h-14">
          <Link to="/" className="flex items-center gap-3" data-testid="portal-brand">
            <img src="/assets/carfin-logo.png" alt="CarFin India" className="h-7" />
            <div className="leading-tight border-l border-slate-700 pl-3 hidden sm:block">
              <div className="text-[10px] uppercase tracking-wider text-teal-300">{title}</div>
            </div>
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <NotificationBell />
            <div className="hidden md:block text-right">
              <div className="font-medium leading-tight">{user?.name}</div>
              <div className="text-xs text-slate-400 capitalize">{user?.role?.replace("_", " ")}</div>
            </div>
            <Button
              variant="ghost"
              size="sm"
              className="text-white hover:bg-slate-800"
              data-testid="portal-logout-btn"
              onClick={async () => { await logout(); navigate("/login"); }}
            >
              <LogOut size={16} className="mr-1" /> Sign out
            </Button>
          </div>
        </div>
      </header>
      <div className="flex flex-1 max-w-[1400px] w-full mx-auto">
        {nav && (
          <aside className="hidden md:block w-56 border-r border-slate-200 bg-white py-4" data-testid="portal-sidebar">
            <nav className="flex flex-col gap-1 px-3">
              {nav.map(n => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.end}
                  data-testid={`sidebar-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className={({ isActive }) =>
                    `px-3 py-2 rounded-md text-sm font-medium transition-colors ${isActive
                      ? "bg-slate-900 text-white"
                      : "text-slate-700 hover:bg-slate-100"}`
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </aside>
        )}
        <main className="flex-1 p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
